var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.$t(_vm.messageI18n)))])}
var staticRenderFns = []

export { render, staticRenderFns }